import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">
                亲亲漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              亲亲漫画网 —— 专注下拉式漫画阅读，为您提供海量免费日漫、韩漫、国漫资源。流畅的下拉式阅读体验，让您沉浸在漫画的世界里。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">漫画分类</h4>
            <ul className="flex flex-wrap gap-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-xs px-2.5 py-1 rounded-full bg-background-700 text-foreground-200 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-base"></i>
                contact@qinqinmanga.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-wechat-line text-base"></i>
                微信公众号：亲亲漫画网
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2024 亲亲漫画网 版权所有 | 专注下拉式漫画阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}